<template>
    <div class="keton">
        <ul>
            <li>RCOR'</li>
            <li>-on</li>
            <li>Oxidation eines sekundären Alkohols</li>
            <li>"mittelständige" Carbonylgruppe</li>
            <li>Reduktion: sekundärer Alkohol</li>
        </ul>
        <img
            src="@/assets/img/stoffe/ketone/allgemeine-struktur.png"
            alt="Allgemeine Struktur der Aldehyde"
            title="Allgemeine Struktur der Aldehyde"
            width="128px"
            height="auto"
        />
    </div>
</template>

<script>
export default {
    name: 'keton',
};
</script>
